import { NavLink, Outlet } from 'react-router-dom';

import List from './List';
import Questions from './Questions';

import Meta from "../../components/Meta";
import Header from "../../components/Header";

import styles from '../../../styles/Admin.module.scss';

const tabClassName = ({ isActive }) => `${styles.tab} ${isActive ? styles.active : ''}`;

function Template() {
	return (
		<>
			<Meta title="Health Screening" />
			<Header heading={"Health Screening"} />
			<main>
				<div className={styles.fullWidth}>
					<div className={styles.tabs}>
						<NavLink end to="/admin/health-screening" className={tabClassName}>Submissions</NavLink>
						<NavLink to="/admin/health-screening/questions" className={tabClassName}>Questions</NavLink>
					</div>

					<div className={styles.tabContent}>
						<Outlet />
					</div>
				</div>
			</main>
		</>
	)
}

export default {
	Template,
	List,
	Questions
};
